




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MenuEngineeringResults extends Vue {
  @Prop(String)
  category!: string;

  @Prop(String)
  restaurantId!: string;

  @Prop(Number)
  dishCount!: number;

  get label(): string {
    const label = this.category === 'LOSER' ? 'LAGGARD' : this.category;
    return label.toLowerCase();
  }

  setRestaurantId() {
    this.$store.commit('restaurant/setActiveRestaurantId', this.restaurantId);
  }
}
